import { BlogContent } from 'domain/blog-content';
import { HomeContent } from 'domain/home-content';
import { latestLaunchesContentful } from 'domain/latest-launches';
import { ProductionsContent } from 'domain/productions-content';
import { UsContent } from 'domain/us-content';
import produce, { Draft } from 'immer';
import { Action, AppAction } from './actions';
import { blogDetailContent } from 'domain/blog-detail-content';
import {AuthState, User} from "../../domain/authTypes";


export interface AppState {
  homeContent: HomeContent;
  productionsContent: ProductionsContent;
  usContent: UsContent;
  blogContent: BlogContent;
  blogDetailContent: blogDetailContent[];
  latestLaunches: latestLaunchesContentful[];
  allLaunches: latestLaunchesContentful[];
  isFetching: boolean;
  auth: AuthState;
  error: null | any;
}

export const initialState: AppState = {
  isFetching: false,
  homeContent: {
    landing: {
      title: [],
      subtitle: [],
    },
    briefInfo: {
      title: '',
      subtitle: '',
      body: '',
    },
    whatWeDo: {
      title: '',
      body: [],
    },
    discover: {
      title: [],
      subtitle: '',
    },
  },
  productionsContent: {
    title: '',
    subtitles: [],
  },
  usContent: {
    imgSrc: '',
    header: {
      title: '',
      subtitle: '',
    },
    teamMembers: [],
  },
  blogContent: {
    header: {
      hero: '',
      title: '',
      subtitle: '',
    },
    podcastingContent: [],
    resourcesContent: [],
  },
  blogDetailContent: [],
  latestLaunches: [],
  allLaunches: [],
  auth: {
    user: null,
    authenticated: false,
    loading: false,
    error: '',
    needVerification: false,
    success: ''
  },
  error: null,
};

export const appReducer = produce((draft: Draft<AppState>, { type, payload }: AppAction) => {
  switch (type) {
    case Action.IsFetching:
      draft.isFetching = true;
      draft.error = null;
      break;
    case Action.FinishedFetching:
      draft.isFetching = false;
      break;
    case Action.ErrorFetching:
      draft.isFetching = false;
      draft.error = payload as any;
      break;
    case Action.ClearError:
      draft.error = null;
      break;
    case Action.SaveHomeContent:
      draft.homeContent = payload as HomeContent;
      break;
    case Action.SaveProductionsContent:
      draft.productionsContent = payload as ProductionsContent;
      break;
    case Action.SaveUsContent:
      draft.usContent = payload as any;
      break;
    case Action.SaveBlogContent:
      draft.blogContent = payload as BlogContent;
      break;
    case Action.SaveBlogDetailContent:
      draft.blogContent = payload as any;
      break;
    case Action.SaveLatestLaunches:
      draft.latestLaunches = payload as latestLaunchesContentful[];
      break;
    case Action.SaveAllLaunches:
      draft.allLaunches = payload as latestLaunchesContentful[];
      break;

    case Action.SetUser:
      draft.auth.user = payload as User;
      draft.auth.authenticated = true;
      break;
    case Action.SetLoading:
      draft.auth.loading = payload;
      break;
    case Action.SignOut:
      draft.auth.user = null;
      draft.auth.authenticated = false;
      draft.auth.loading = false;
    break;
    case Action.SetError:
      draft.auth.error = payload;
      break;
    case Action.NeedVerification:
      draft.auth.needVerification = true;
      break;
    case Action.SetSuccess:
      draft.auth.success = payload;
      break;

    case Action.ClearData:
      return initialState;
    default:
      throw new Error(`Unknown type: ${type}`);
  }
});
